import React, { useState } from "react";
import "./input.component.scoped.sass";
import { useTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField/TextField";
import { icons } from "src/statics/icons";
import { FormInputProps } from "src/types/form-input-props";

export const InputComponent = (props: FormInputProps) => {
  const { icon, label, id, validate, error, type, focused } = props;
  const [t] = useTranslation();
  const iconReady: any = icons[`${icon}Ico`];
  const [active, setActive] = useState(false);

  const setActiveInput = (type: boolean) => {
    setActive(type);
  }

  return (
    <>
      <div className={"input-wrapper " + (active ? "active" : "")}>
        <img alt="icon" className="icon" src={iconReady} />
        <div className="wrapper">
          <TextField
            focused={focused}
            onFocus={setActiveInput.bind(null, true)}
            onBlur={setActiveInput.bind(null, false)}
            error={error ? true : false}
            id={id}
            type={type || 'text'}
            label={t(label!)}
            onInput={validate}
          />
        </div>
      </div>
      <div className="error-msg">{t(error!)}</div>
    </>
  );
};
